<template>
  <div>
    <v-card class="user-filter-card pa-5 elevation-3">
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            id="searchIdNameTel"
            v-model="searchInfo.userInfo"
            :label="$t('search.userInfo')"
            :placeholder="$t('search.userInfoPlaceholder')"
            outlined
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            id="searchUserType"
            v-model="searchInfo.userType"
            :items="userTypeList"
            item-text="text"
            item-value="value"
            :label="$t('general.userType')"
            outlined
            clearable
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            id="searchUserStatus"
            v-model="searchInfo.status"
            :items="statusList"
            item-text="text"
            item-value="value"
            :label="$t('general.status')"
            outlined
            clearable
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            id="searchUserGender"
            v-model="searchInfo.gender"
            :items="genderList"
            item-text="text"
            item-value="value"
            :label="$t('general.gender')"
            outlined
            clearable
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-dialog
            ref="dateFromDialog"
            v-model="showDateFromPicker"
            :return-value.sync="searchInfo.joinDateFrom"
            persistent
            width="320px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="searchInfo.joinDateFrom"
                :label="$t('search.dateFrom')"
                readonly
                outlined
                clearable
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="searchInfo.joinDateFrom"
              :locale="convertLocale(currentLocale, 'bcp47')"
              :max="searchInfo.joinDateEnd"
              scrollable
              @input="setDate(searchInfo.joinDateFrom, 'dateFromDialog', showDateFromPicker)"
            />
          </v-dialog>
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-dialog
            ref="dateEndDialog"
            v-model="showDateEndPicker"
            :return-value.sync="searchInfo.joinDateEnd"
            persistent
            width="320px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="searchInfo.joinDateEnd"
                :label="$t('search.dateEnd')"
                readonly
                outlined
                clearable
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="searchInfo.joinDateEnd"
              :locale="convertLocale(currentLocale, 'bcp47')"
              :min="searchInfo.joinDateFrom"
              scrollable
              @input="setDate(searchInfo.joinDateEnd, 'dateEndDialog', showDateEndPicker)"
            />
          </v-dialog>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn
          color="primary"
          @click="search()"
        >
          {{ $t('common.search') }}
        </v-btn>
        <v-btn
          color="accent darken-3"
          @click="clear()"
        >
          {{ $t('common.clear') }}
        </v-btn>
        <v-btn
          color="secondary"
          @click="add()"
        >
          {{ $t('common.add', {item: null}) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'

export default {
  name: 'UserFilter',
  mixins: [ErrorDisplay],
  data: function () {
    return {
      searchInfo: {
        userInfo: null,
        userType: null,
        status: null,
        gender: null,
        joinDateFrom: null,
        joinDateEnd: null
      },
      userTypeList: [
        { value: 'usr', text: this.$t('general.user') },
        { value: 'adm', text: this.$t('general.admin') }
      ],
      statusList: [
        { value: 0, text: this.$t('general.inactive') },
        { value: 1, text: this.$t('general.active') },
        { value: -1, text: this.$t('general.banned') }
      ],
      genderList: [
        { value: 0, text: this.$t('general.male') },
        { value: 1, text: this.$t('general.female') }
      ],
      showDateFromPicker: false,
      showDateEndPicker: false
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    setDate (date, ref, modal) {
      this.$refs[ref].save(date)
      modal = false
    },
    search () {
      this.$emit('search', this.searchInfo)
    },
    add () {
      this.$emit('add')
    },
    clear () {
      for (const key in this.searchInfo) {
        this.searchInfo[key] = null
      }
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
  .user-filter-card {
    width: 100%
  }
</style>
